// config/domain.ts
// Dominio base del sito. Whitelabel: basta impostare VITE_DOMAIN per rebrandizzare.
export const DOMAIN = import.meta.env.VITE_DOMAIN || 'escortfun.net';

export const SITE_URL = `https://${DOMAIN}`;
export const API_DOMAIN = `https://api.${DOMAIN}`;
export const MY_DOMAIN = `https://my.${DOMAIN}`;
export const IMG_DOMAIN = `https://img.${DOMAIN}`;
export const COOKIE_DOMAIN = `.${DOMAIN}`;
export const TITLE = import.meta.env.VITE_TITLE || 'EscortFun.net';

// Nome breve derivato dal dominio (estensione rimossa), es. 'escortfun.net' -> 'escortfun'
export const BRAND_SHORT = DOMAIN.replace(/\.[a-z]+$/i, '');
// Estensione del dominio, es. '.net'
export const BRAND_EXTENSION = DOMAIN.slice(BRAND_SHORT.length);
